import VueDraggableNext from 'vuedraggable'

export default defineNuxtPlugin((NuxtApp) => {
  NuxtApp.vueApp.component('draggable', VueDraggableNext)
})
